var React = require('react');
var router = require('react-router');
var Link = router.Link;

var FAQ_ITEMS = require('../faq-items');

var PAGE_TITLE = 'Poker Tournament FAQ | Daily Tourneys';

var GuideFaq = React.createClass({
  componentDidMount: function() {
    document.title = PAGE_TITLE;
  },
  componentWillUnmount: function() {
    document.title = 'Daily Tourneys | U.S. Casino & Poker Room Tournament Schedules';
  },
  render: function() {
    var items = FAQ_ITEMS.map(function(item) {
      return (
        <div className="faq-item" key={item.q}>
          <h2>{item.q}</h2>
          <p>{item.a}</p>
        </div>
      );
    });

    return (
      <article className="content-page guide-page faq-page">
        <div className="detail-toolbar">
          <Link to="/" className="back-link">← Back to search</Link>
        </div>
        <h1 className="content-h1">Poker tournament FAQ</h1>
        <p className="content-lead">
          Short answers about daily casino tournaments, buy-ins, schedules, and how to use Daily Tourneys.
        </p>
        <div className="faq-list">
          {items}
        </div>
        <p className="home-intro-links">
          Browse hubs: <Link to="/las-vegas-poker-rooms">Las Vegas</Link>
          {' · '}
          <Link to="/houston-poker-rooms">Houston</Link>
          {' · '}
          <Link to="/los-angeles-poker-rooms">Los Angeles</Link>
          {' · '}
          <Link to="/seattle-poker-rooms">Seattle</Link>
          {' · '}
          <Link to="/texas-poker-rooms">Texas</Link>
          {' · '}
          <Link to="/california-poker-rooms">California</Link>
          {' · '}
          <Link to="/florida-poker-rooms">Florida</Link>
          {' · '}
          <Link to="/washington-poker-rooms">Washington</Link>
        </p>
        <p className="home-intro-links">
          Rooms with schedules: <Link to="/allcasinos/Commerce_Casino">Commerce Casino</Link>
          {' · '}
          <Link to="/allcasinos/Wynn4_Las_Vegas">Wynn Las Vegas</Link>
          {' · '}
          <Link to="/allcasinos/Texas_Card_House_Houston">Texas Card House Houston</Link>
          {' · '}
          <Link to="/allcasinos/Sycuan_Casino">Sycuan Casino</Link>
        </p>
        <p className="content-cta">
          More detail: <Link to="/guides/how-daily-tournaments-work">how dailies work</Link>
          {' · '}
          <Link to="/guides/tournament-terms">tournament terms</Link>
          {' · '}
          <Link to="/">search schedules</Link>
        </p>
      </article>
    );
  }
});

module.exports = GuideFaq;



// WEBPACK FOOTER //
// ./js/pages/guide-faq.jsx